import { useIsPreview } from './previewStore'

// Faixa fixa no topo indicando que o portal esta em modo preview (read-only),
// aberto pela equipe dentro do ERP. So aparece quando isPreview = true.
export function PreviewRibbon() {
  const isPreview = useIsPreview()
  if (!isPreview) return null
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#FF4D00',
        color: '#fff',
        fontSize: 12,
        fontWeight: 600,
        textAlign: 'center',
        padding: '4px 12px',
        letterSpacing: 0.3,
        fontFamily: "'Poppins', Arial, sans-serif",
      }}
    >
      Modo preview: visão da equipe, somente leitura
    </div>
  )
}
